import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {filterAutocomplete_template} from "./filterAutocomplete_template";
import {validationsList_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template';
import {filterArticle_template} from "./filterArticle_template";

declare var ko: any;

export class headerFeaturedArticlesEdit_template extends vnTemplate {

    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;
    public articleFilter: filterAutocomplete_template;
    protected validationsList: validationsList_template;
    protected previousCategory;
    protected previousArticle;

    protected initPartial() {
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller)
        this.pagination.getTemplateViewModel().itemPerPage = 10;
        this.articleFilter = new filterAutocomplete_template("articleFilter", this.getTemplateViewModel(), this.caller);
        this.articleFilter.setPlaceholderAndLabel("Article");
        this.articleFilter.setOptionType("Article");
        this.articleFilter.setNumberOfChars( 1 );
        this.articleFilter.setAddNewOptionEnabled(false);
        this.articleFilter.setFilterIconCSSClass('i-article-a')
        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);

    }

    protected buildViewModel(): any {
        let huit_neuf_this = this;
        return {
            menus : ko.observableArray([]),
            isAddArticleVisible : ko.observable(false),
            featuredArticles : ko.observableArray([]),
            categoryName : ko.observable(""),
            title : ko.observable(""),
            categories : ko.observableArray([]),
            categoriesWithoutDefault : ko.observableArray([]),
            idCategory : ko.observable(),
            objectKeys : ko.observableArray([]),
            viewEditItems : ko.observable(false),
            isCategoryVisible: ko.observable(true),
            article : ko.observableArray([]),
            pinnedHeader :  ko.observableArray([]),
            allToggleIdsOpened : ko.observable([]),
            alternateTitle : ko.observable(""),
            isDefaultSelected : ko.observable(false),
            onClickView : function (data, event) {
                huit_neuf_this.onClickView(data.id)
            },
            onClickDelete : function (data, event){
                huit_neuf_this.onClickDelete(data,event)
            },
            onClickEdit : function (data, event) {
                huit_neuf_this.onClickEdit()
            },
            onClickSave: function (data, event) {
                huit_neuf_this.onClickSave();
            },
            onClickCancel: function (data, event) {
                huit_neuf_this.onClickCancel();
            },
            onClickAdd: (data, event) => {
                huit_neuf_this.onClickAdd(data,event);
            },
            onClickToggleCollapse: (data, event) => {
                huit_neuf_this.onClickToggleCollapse(data, event);
            },
            onClickAddArticleCancel: (data, event) => {
                huit_neuf_this.onClickAddArticleCancel();
            },
            onClickApplyArticle: (data, event) => {
                huit_neuf_this.onClickApplyArticle(data,event);
            },
            onClickAddWithCategory: (data, event) => {
                huit_neuf_this.onClickAddWithCategory(data,event);
            }
        }
    }

    protected getTemplateHtml(): string {
        return (

            `               
            <div class="w-form ">
                <div class="form-header">
                    
                    <input type="hidden">
                
                    <h3 class="form-title icon i-listing-page">Header Articles</h3>
                
                    <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2" type="button"></button>
                </div>
           
                <div class="form-body ">
                   
                        
                    <div class="w-section" data-bind="foreach: featuredArticles">
                        
                        <div class="w-form-sub-title" style="margin-bottom: 1rem" data-bind="event: { click: $parent.onClickToggleCollapse}">
                            <strong class="form-sub-title icon i-dropdown-simple" data-bind="text: categoryName"></strong>
                            <!-- <button data-bind="event: { click: $parent.onClickEdit}" class="btn icon light" type="button" style="">See More</button>-->
                        </div>
                        <div class="w-list" data-bind="attr: { id: 'toggleHeader_' + categoryId }">
                            <table class="list-action">
                            <!--
                                <thead>
                                    <tr class="destinable "data-bind="attr: { id: 'draggableMenuItem_cat_' + id }">
                                        <th><span>Priority</span></th>
                                        <th><span>Article Title</span></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                -->
                                <tbody data-bind="foreach : articles ">
                                
                                    <tr  class="cursor draggable " draggable="true" data-bind="attr: { id: 'draggableMenuItem_' + id }" >
                                    
                                        <td class="no-border"><span class="icon i-drag"></span></td>
                                        <!-- <td><span data-bind="text: $data.priority"></span></td> -->
                                        <!-- ko if: $data.alternateTitle -->
                                            <td class="no-border"><span data-bind="text: $data.alternateTitle"></span></td>
                                        <!-- /ko -->
                                        <!-- ko ifnot: $data.alternateTitle -->
                                        
                                            <td class="no-border"><span data-bind="text: $data.articleTitle"></span></td>
                                        <!-- /ko -->
                                        <td class="no-border align-right">      
                                            <button data-bind="event: { click: $root.headerFeaturedArticlesEditTemplate.onClickDelete }" class="btn-form icon icon-only highlight i-delete"><span class="hidden-text">Delete</span></button>  
                                       </td>
                                    </tr>
                                    
                                </tbody>
                            </table>
                            <div class="form-group">
                                <button data-bind="event: {click: $root.headerFeaturedArticlesEditTemplate.onClickAddWithCategory}" class="btn secondary icon i-add" type="button">add Article</button>  
                            </div>
                        </div>
                    </div>
                    <div class="form-body">
                        <div class="form-group"><hr></div>
                       <div class="form-group">
                            <button data-bind="event: {click: $root.headerFeaturedArticlesEditTemplate.onClickAdd}" class="btn secondary icon i-add" type="button">Add Category</button>    
                       </div>
                    </div>
                </div>
                <div class="form-footer">
                    <button data-bind="event: { click: onClickCancel }" class="btn" type="button">Cancel</button>
                    <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>
                </div>
            </div>
                  
            <div class="w-lightbox light-theme" data-bind="css: { 'is-visible': isAddArticleVisible }">
                <div class="lightbox-content">
                        
                    <div class="w-form lightbox-form" style="width: 50rem;">
                        <div class="form-header">
                            <h3 class="form-title">Add Article</h3>
                            <button data-bind="event: {click: $root.headerFeaturedArticlesEditTemplate.onClickAddArticleCancel}" type="button" class="close-button icon i-close-2"></button>
                        </div>
                   
                        <div class="form-body">
                        
                            <div class="form-group">
                                <div data-bind="visible: isCategoryVisible" class="form-group" style="margin-bottom: 4rem">
                                   <label class="form-label form-label-box" for="cat">Category</label>
                                   <select id="cat" data-bind="options: categoriesWithoutDefault, optionsText: 'name', value: idCategory, optionsValue: 'id',valueAllowUnset: true"></select>
                                </div>
                            </div>   
                            
                            <div class="form-group" style="margin-top: 2rem">                                                       
                                    ${ this.articleFilter.getHtmlBuild() }                         
                            </div>
                            <div class="form-group" style="margin-top: 2rem">   
                                <label for="" class="form-label">Alternate Title</label>
                                <input type="text" class="input-text" data-bind="value :alternateTitle"/>        
                            </div>     
                         </div>
                
                        <div class="form-footer">
                            <button data-bind="event: {click: $root.headerFeaturedArticlesEditTemplate.onClickAddArticleCancel}" class="btn" type="button">Cancel</button>
                            <button data-bind="event: {click: $root.headerFeaturedArticlesEditTemplate.onClickApplyArticle}" class="btn highlight" type="button">Apply</button>
                        </div>
                    </div>
                   
                </div>
            </div>
            
            
             `

        );
    }

    protected getTemplateName(): string {
        return "headerFeaturedArticlesEditTemplate";
    }

    protected getMainElementClasses(): Array<string> {
        return [""];
    }

    public setMenu(categories,featuredArticlesObj,categoriesWithoutDefault){
        this.getTemplateViewModel().featuredArticles(featuredArticlesObj)
        this.getTemplateViewModel().categories(categories)
        this.getTemplateViewModel().categoriesWithoutDefault(categoriesWithoutDefault)
        this.initFeaturedHeaderArticles();
        this.onLoadCategoryOpen();
        this.onLoadTemplate('.draggable', this);
    }
    public onClickView(id) {

        this.onLoadTemplate('.draggable', this);
    }

    public onClickEdit(){
        this.getTemplateViewModel().viewEditItems(true);

        this.onLoadTemplate('.draggable', this);
    }


    public onClickDelete(data,event){
        let viewModelCategory = this.getTemplateViewModel().featuredArticles();
        let categoryId = viewModelCategory.findIndex(x=>x["categoryName"] === data.categoryName)
        let articleObj = viewModelCategory[categoryId].articles.findIndex(x=>x["articleId"] === data.articleId)
        viewModelCategory[categoryId].articles.splice(articleObj, 1);
        this.getTemplateViewModel().featuredArticles([]);
        this.getTemplateViewModel().featuredArticles(viewModelCategory);
        this.onLoadTemplate('.draggable', this);

    }

    public onClickAdd(data,event){
        this.getTemplateViewModel().isAddArticleVisible(true);
        this.getTemplateViewModel().isCategoryVisible(true);
        this.getTemplateViewModel().idCategory(this.getTemplateViewModel().categories()[0].id);
        //this.caller.addArticle();

        this.onLoadTemplate('.draggable', this);
    }

    public onClickAddWithCategory(data,event){
        this.getTemplateViewModel().isCategoryVisible(false);
        this.getTemplateViewModel().isAddArticleVisible(true);
        let categories = this.getTemplateViewModel().categories();
        let categoryObj = categories.find(x=>x.name == data.categoryName);

        this.getTemplateViewModel().idCategory()
        if(categoryObj.id == null){
            this.getTemplateViewModel().idCategory(null);
        }else{

            this.getTemplateViewModel().idCategory(categoryObj.id);
        }
        //need to set the catgory id now

        //this.caller.addArticle();

        this.onLoadTemplate('.draggable', this);
    }
    public onLoadCategoryOpen(){
        let toggleOpened = this.getTemplateViewModel().allToggleIdsOpened();
        let viewModelCategory = this.getTemplateViewModel().featuredArticles();
        let categoryId = viewModelCategory.findIndex(x=>x["categoryId"] === null)

        if(categoryId == 0 && toggleOpened.length >0){

            for(let toggle of toggleOpened){
                if(toggle !==null){
                    toggleOpened.push(null);
                }
            }
        }else if(categoryId == 0){
            toggleOpened.push(null);
        }
    }
    public initFeaturedHeaderArticles(){
        let viewModelCategory = this.getTemplateViewModel().featuredArticles();
        let categoryId = viewModelCategory.findIndex(x=>x["categoryId"] === null)
        if(categoryId !=0 && categoryId<0){

            let categoryObject =
                {
                    "articles": [],
                    "categoryName":"Default",
                    "id":null,
                    "categoryId": null,
                    "priority":0
                }

            viewModelCategory.unshift(categoryObject)
            this.getTemplateViewModel().featuredArticles([])
            this.getTemplateViewModel().featuredArticles(viewModelCategory)
        }
    }
    public keepActiveCategoryOpen(){
        let toggleOpened = this.getTemplateViewModel().allToggleIdsOpened();

        for(let toggle of toggleOpened){

            let nextSibling = document.getElementById("toggleHeader_"+ toggle);
            nextSibling.classList.add("is-open");
        }
    }
    public onClickToggleCollapse(data, event){

        let nextSibling = event.currentTarget.nextElementSibling;
        let previousSibiling = event.currentTarget.previousSibling.nextElementSibling.firstElementChild;
        let toggleOpened = this.getTemplateViewModel().allToggleIdsOpened()
        if (!nextSibling.classList.contains("is-open"))  {
            nextSibling.classList.add("is-open");
            toggleOpened.push(data.categoryId);
            this.getTemplateViewModel().allToggleIdsOpened([])
            this.getTemplateViewModel().allToggleIdsOpened(toggleOpened)

        } else {
            nextSibling.classList.remove("is-open");
            let index = toggleOpened.indexOf(data.categoryId);
            if(index>=0){
                toggleOpened.splice(index,1);
            }
            this.getTemplateViewModel().allToggleIdsOpened([])
            this.getTemplateViewModel().allToggleIdsOpened(toggleOpened)
        }

        if (!previousSibiling.classList.contains("is-open"))  {
            previousSibiling.classList.add("is-open");
        } else {
            previousSibiling.classList.remove("is-open");
        }
    }

    protected onClickSave() {

        this.caller.save();
    }
    protected clearEdit(){

        //this.getTemplateViewModel().categories([]);
        this.getTemplateViewModel().article([]);
        this.getTemplateViewModel().alternateTitle("");
        this.getTemplateViewModel().isDefaultSelected(false);
        this.articleFilter.clearEverything();
        this.setIdCategory(null);
    }
    protected onClickAddArticleCancel(){
        this.getTemplateViewModel().isAddArticleVisible(false);
        this.clearEdit();
    }

    protected onClickApplyArticle(data,event){
        let categoryId = this.getTemplateViewModel().idCategory();
        let categories = this.getTemplateViewModel().categories();
        let featuredArticles = this.getTemplateViewModel().featuredArticles();
        let articleFilter = this.getTemplateViewModel().articleFilter.optionObj();
        let categoryObj = categories.find(x=>x.id ==categoryId);
        let allToggles = this.getTemplateViewModel().allToggleIdsOpened();
        let alternateTitle = this.getTemplateViewModel().alternateTitle();

        //let categoryObj = categories[categoryObjId];

        //Need to make the object and then push

        let catIndex = featuredArticles.findIndex(x=>x.categoryName == categoryObj.name)
        if(this.getTemplateViewModel().isDefaultSelected()){
            categoryId = null;
            categoryObj.id = null;
            categoryObj.name = "Default";
        }
        if(catIndex <0){
            let maxPriority = 0;
            let newArticleObj = [
                {   "articleId": articleFilter.id,
                    "articleTitle": articleFilter.name ,
                    "alternateTitle":alternateTitle,
                    "categoryName": categoryObj.name,
                    "categoryId": categoryId,
                    "id": null,
                    "priority":maxPriority+1
                }];
            let categoryObject =
                {
                    "articles": newArticleObj,
                    "categoryName":categoryObj.name,
                    "id":articleFilter.id,
                    "categoryId": categoryId,
                    "priority":1
                }

            allToggles.push(categoryId);
            this.getTemplateViewModel().allToggleIdsOpened([]);
            this.getTemplateViewModel().allToggleIdsOpened(allToggles);
            featuredArticles.push(categoryObject)

        }else{
            let featuredArticleObj = featuredArticles.find(x=>x.categoryName == categoryObj.name)
            let maxPriority =0;
            if(featuredArticleObj.articles.length >0){

                maxPriority = Math.max(...featuredArticleObj.articles.map(o => o.priority))
            }
            let newArticleObj =
                {
                    "articleId": articleFilter.id,
                    "articleTitle": articleFilter.name ,
                    "alternateTitle":alternateTitle,
                    "categoryName": categoryObj.name,
                    "categoryId": categoryId,
                    "id": null,
                    "priority":maxPriority+1
                };
            let ifFound =null;
            if(featuredArticleObj.articles !==null){

                ifFound = featuredArticleObj.articles.find(x=>x.articleId ==articleFilter.id);
            }
            if(ifFound == null){
                allToggles.push(categoryId);
                this.getTemplateViewModel().allToggleIdsOpened([]);
                this.getTemplateViewModel().allToggleIdsOpened(allToggles);

                featuredArticleObj.articles.push(newArticleObj);
            }

            featuredArticles[catIndex] = featuredArticleObj;
        }
        this.getTemplateViewModel().featuredArticles([]);
        this.getTemplateViewModel().featuredArticles(featuredArticles);
        this.onClickAddArticleCancel();
        this.onLoadTemplate('.draggable', this);

    }

    protected onClickCancel() {

        this.caller.cancel();
    }
    public setCategories(categories){
        this.getTemplateViewModel().categories(categories);
    }

    public setIdCategory(idCategory):void{
        this.getTemplateViewModel().idCategory(idCategory);
    }
    // Drag and drop functionality
    // @TODO: convert the following to a re-usable library!
    public onLoadTemplate(dragItemSelector, huit_neuf) {

        var dragSrcEl = null;
        var dragSrcId = null;
        var dragItemIdPrefix = "draggableMenuItem_";
        var dragItemHeaderIdPrefix = "draggableMenuItem_cat_";

        function handleDragStart(e) {

            // @TODO: remove any elements visible because the dragged element was hovered

            if (e.stopPropagation) {
                e.stopPropagation(); // Prevent the parent item from being considered the dragged item
            }

            // Target (this) element is the source node.
            dragSrcEl = this;
            dragSrcId = e.srcElement.id;

            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('text/html', this.outerHTML);

            this.classList.add('dragElem');
        }

        function handleDragOver(e) {

            console.log('dragging over');

            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            if (e.stopPropagation) {
                e.stopPropagation(); // Prevent the parent/child element from both being 'dragged over' simultaneously
            }

            let huit_neuf_this = this;
            var dragItems = document.querySelectorAll(dragItemSelector);
            let found = false;
            for(let item of dragItems){

                if(dragSrcEl == item){

                    huit_neuf_this.classList.add('after');
                    huit_neuf_this.classList.remove('before');
                    found = true;
                    break;
                }
                if(this == item){

                    huit_neuf_this.classList.add('before');
                    huit_neuf_this.classList.remove('after');
                    found = true;
                    break;
                }
            }

            if(!found){
                this.classList.add("before");
            }

            e.dataTransfer.dropEffect = 'move';  // See the section on the DataTransfer object.

            return false;
        }

        function handleDragEnter(e) {

            // this / e.target is the current hover target.
            this.classList.add('over');
            this.classList.add('before');
        }

        function handleDragLeave(e) {

            this.classList.remove('before');
            this.classList.remove('after');  // this / e.target is previous target element.
        }

        function handleDrop(e) {

            // @TODO not type safe in here..

            // this/e.target is current target element.
            if (e.stopPropagation) {
                e.stopPropagation(); // Stops some browsers from redirecting.
            }
            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            // Don't do anything if dropping the same column we're dragging.
            if (dragSrcEl != this) {

                // necessary data
                let popItem, popKey, popArtKey, destKey, destArtKey;
                let categories = huit_neuf.getTemplateViewModel().featuredArticles();
                let destinationID = this.id;
                let destIsHeader = false;
                let dragSrcIdInt = parseInt(dragSrcId.substring(dragItemIdPrefix.length)); // integer id of the element that was dragged..
                if (destinationID.indexOf(dragItemHeaderIdPrefix) >= 0) { // the destination element is a header..
                    destIsHeader = true;
                    destinationID = parseInt(destinationID.substring(dragItemHeaderIdPrefix.length));

                } else  if (destinationID.indexOf(dragItemIdPrefix) >= 0) { // the destination element is an article..
                    destinationID = parseInt(destinationID.substring(dragItemIdPrefix.length));
                }
                let oldElement = document.querySelector('tr[id=\''+dragSrcId+'\']');
                let dropHTML = oldElement.outerHTML;

                // update the existing markup..
                oldElement.remove();
                if(this.classList.contains("before")){
                    this.insertAdjacentHTML('beforebegin',dropHTML);
                    var relativePosition = 'before';
                }else{
                    this.insertAdjacentHTML('afterend',dropHTML);
                    var relativePosition = 'after';
                }

                // filter the categories array for the dragged and destination items
                let i = 0;
                let len = categories.length;
                for (; i < len; i++) {
                    let z = 0;
                    let zLen = categories[i].articles.length;
                    if ((categories[i].id == destinationID) && destIsHeader) { // the destination is a header.. put the article at the top (0)
                        destKey = i;
                        destArtKey = 0;
                    }
                    for(; z < zLen; z++) {
                        if (categories[i].articles[z].id == dragSrcIdInt) {
                            popItem = categories[i].articles[z];
                            popKey = i;
                            popArtKey = z;
                        }
                        if ((categories[i].articles[z].id == destinationID) && (!destIsHeader)) { // the destination is an article.. structure accordingly
                            destKey = i;
                            destArtKey = (relativePosition == 'before') ? z : z + 1;
                        }
                    }
                }

                // Update the categories array
                if(
                    typeof popItem !== 'undefined' && popItem !== null &&
                    typeof popKey !== 'undefined' && popKey !== null &&
                    typeof popArtKey !== 'undefined' && popArtKey !== null &&
                    typeof destKey !== 'undefined' && destKey !== null &&
                    typeof destArtKey !== 'undefined' && destArtKey !== null
                ){
                    categories[popKey].articles.splice(popArtKey, 1); // remove from old position
                    categories[destKey].articles.splice(destArtKey, 0, popItem); // place in new position
                }

                // reset the priorities and categories on the article entries based on the new sorting
                i = 0;
                len = categories.length;
                for (; i < len; i++) {
                    let z = 0;
                    let zLen = categories[i].articles.length;
                    for(; z < zLen; z++) {
                        categories[i].articles[z].priority = z+1;
                        categories[i].articles[z].categoryName = categories[i].categoryName;
                        categories[i].articles[z].categoryId = categories[i].categoryId;
                    }
                }

                // push the changes to the view model
                huit_neuf.getTemplateViewModel().featuredArticles([]);
                huit_neuf.getTemplateViewModel().featuredArticles(categories);
                huit_neuf.onLoadTemplate('.draggable', huit_neuf);


            }

            this.classList.remove('before');
            this.classList.remove('after');
            return false;
        }

        function handleDragEnd(e) {

            // this/e.target is the source node.
            this.classList.remove('before');
            this.classList.remove('after');

            [].forEach.call(cols, function (col) {

                col.classList.remove('before');
                col.classList.remove('after');
            });
        }

        function addDnDHandlers(elem) {

            elem.addEventListener('dragstart', handleDragStart, false);
            elem.addEventListener('dragenter', handleDragEnter, false)
            elem.addEventListener('dragover', handleDragOver, false);
            elem.addEventListener('dragleave', handleDragLeave, false);
            elem.addEventListener('drop', handleDrop, false);
            elem.addEventListener('dragend', handleDragEnd, false);
        }

        var cols = document.querySelectorAll('[draggable=true], .destinable');
        [].forEach.call(cols, addDnDHandlers);
        huit_neuf.keepActiveCategoryOpen();
    }
    public clearMessages(): void {

        this.validationsList.clearMessages();
    }

    protected setArticleFilterAutocomplete(articles): void  {

        this.articleFilter.setOptions(articles);
    }
    public setArticle(articleObj){

        if(articleObj !== null){
            articleObj[0].article.name = articleObj[0].article.title;
            this.articleFilter.setOption(articleObj[0].article);
        }
        this.getTemplateViewModel().article(articleObj[0]);
        //
        // this.getTemplateViewModel().title(articleObj[0].articleTitle);
        //
        // //this.articleFilter.setPlaceholderAndLabel(articleObj[0].articleTitle);

    }
    public getOptionObj(){
        return this.getTemplateViewModel().article();
    }
    public setPinnedArticle(idElement) {

        let index = idElement.replace('filterArticle','');
        let x = this.getTemplateViewModel().pinnedHeader();
        let chosenArticle = x[index].articleFilter.getTemplateViewModel().articleObj();

        x[index].position = (Number(index) + 1);
        x[index].idEmakiArticle = chosenArticle.id;
        x[index].emakiArticle = chosenArticle;
        x[index].expire = null;
        x[index].timeLeft = null;
        x[index].pinnedHours = null;
        x[index].articleFilter = new filterArticle_template("filterArticle"+index, this.getTemplateViewModel(), this.caller);

        this.getTemplateViewModel().pinnedHeader([]);
        this.getTemplateViewModel().pinnedHeader(x);
    }

    public setPinnedArticlesList(pinnedArticles: Array<any>): void {

        let x = [];
        for (let y=0;y< 6;y++) {
            x[y] = {
                'id': null,
                'position': (y + 1),
                'idEmakiArticle': null,
                'emakiArticle': null,
                'expire': null,
                'pinnedHours': null,
                'timeLeft': null,
                'articleFilter':  new filterArticle_template("filterArticle"+y, this.getTemplateViewModel(), this.caller)
            };
        }

        for (let p of pinnedArticles) {
            x[p.position -1] = p;
            x[p.position -1]['pinnedHours'] = null;
            x[p.position -1]['articleFilter'] = new filterArticle_template("filterArticle"+(p.position -1), this.getTemplateViewModel(), this.caller);
        }

        this.getTemplateViewModel().pinnedHeader(x);

    }

    protected onClickAddToPinnedArticlesList(): void {

        let pinnedHours = this.getTemplateViewModel().pinnedHours();

        let selectedArticle = this.articleFilter.getOptionObj();
        let pinnedArticles = this.getTemplateViewModel().pinnedArticles();

        // selected article must be entered, if pinnedhours is entered it must be an integer.. and must be positive
        if( selectedArticle != null && ( (!pinnedHours) || ( !isNaN(parseInt(pinnedHours)) && Number.isInteger(parseInt(pinnedHours)) && (parseInt(pinnedHours) > 0) ) ) ) {

            // checking that article doesn't exist in array
            let found = pinnedArticles.find((a) => a.reference == selectedArticle.reference);

            if (found == undefined) {
                let newPinnedArticle: any = {
                    reference: selectedArticle.reference,
                    title: selectedArticle.title,
                    timeLeft: (pinnedHours) ? pinnedHours + ":00:00" : '',
                    pinnedHours: pinnedHours,
                };

                pinnedArticles.push(newPinnedArticle);
                this.getTemplateViewModel().pinnedHeader(pinnedArticles);
                this.articleFilter.clearInput();
            }

        }

    }

    public removeValidationClass() {

        document.body.classList.remove('_form-sub')
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/headerFeaturedArticlesEdit_template.ts